module.exports = __webpack_public_path__ + "img/reviews.9b59bb25.svg";